import { useEffect } from "react";

// The ChatHR experience lives in a framework-free page (the same code shipped
// inside the WordPress plugin), served from /chathr-demo.html.
function App() {
  useEffect(() => {
    window.location.replace("/chathr-demo.html");
  }, []);
  return null;
}

export default App;
